import consumer from "./consumer"

consumer.subscriptions.create("AccountChannel", {
  received(data) {
    if (data.message === "Orden validada exitosamente") {
      setTimeout(() => {
        Turbo.visit("/order_completed")
      }, 1500)
    }
  }
})